import React, { useState, useEffect, useContext } from 'react'
import ModalBox from '../../../../templates/components/ModalBox';
import ValidationConstant from '../../../../../services/validator/validation.constant';
import FormValidatorService from '../../../../../services/validator/form-validator.service';
import DimLoader from '../../../../templates/components/DimLoader';
import { store } from '../../../../../context/StateProvider';
import HPTSelect from '../../../../templates/components/HPTSelect';

const NoteTemplateForm = (props) => {
    // Pull properties from parent
    const { isEdit, submitHandler } = props;
    // Set states for form
    const globalStateAndDispatch = useContext(store)
    const state = globalStateAndDispatch.state
    const [isLoader, setIsLoader] = useState(false)
    const [formData, setFormData] = useState(props.initialData || {})
    const [errors, setErrors] = useState({})
    const required = ['shortCode', 'notes']
    const [confirm, setConfirm] = useState(false)
    const [locationId, setLocationId] = useState(isEdit ? props.initialData?.practiceLocationId || null : state?.practiceLocationId || null)
    const practiceLocation = state?.practiceLocations || []
    const NoteTemplateFormConfig = {
        config: {
            'ShortCode': {
                required: { name: ValidationConstant.noteTemplete.add.shortCode.name },
                minlength: {
                    name: ValidationConstant.noteTemplete.add.shortCode.name,
                    min: ValidationConstant.noteTemplete.add.shortCode.minLength.toString()
                },
            },
            'Notes': {
                required: { name: ValidationConstant.noteTemplete.add.notes.name },
                maxlength: {
                    name: ValidationConstant.noteTemplete.add.notes.name,
                    max: ValidationConstant.noteTemplete.add.notes.maxLength.toString()
                },
                minlength: {
                    name: ValidationConstant.noteTemplete.add.notes.name,
                    min: ValidationConstant.noteTemplete.add.notes.minLength.toString()
                },
            }
        }
    }


    // formula for input change
    const inputChange = (e) => {
        setErrors(FormValidatorService.setErrors(e, errors, NoteTemplateFormConfig.config))
        let newStateObject = { ...formData };
        newStateObject[e.target.name] = e.target.value;
        setFormData(newStateObject);
    };


    useEffect(() => {
        //console.log('locationId changed in NoteTemplateForm:', locationId);
        inputChange({
            target: {
                name: 'practiceLocationId', value: locationId
            }
        })
    }, [locationId]);

    return (
        <>
            {isLoader && <DimLoader loadMessage="Loading..." />}
            <form className=''>
                <div className="field col-12">
                    <label>
                        Short Code <span style={{ color: 'red' }}>*</span>
                    </label>
                    <input
                        onChange={(e) => {
                            e.preventDefault();
                            inputChange(e);
                        }}
                        placeholder="Short Code"
                        type="text"
                        name="shortCode"
                        value={formData.shortCode}
                        required
                    />
                    <span className="error-message">{errors?.shortCode}</span>
                </div>

                <div className="field">
                    <label>
                        Notes <span style={{ color: 'red' }}>*</span>
                    </label>
                    <textarea
                        onChange={(e) => {
                            e.preventDefault();
                            inputChange(e);
                        }}
                        placeholder="Enter your notes template here..."
                        name="notes"
                        value={formData.notes}
                        rows="8"
                        required
                    ></textarea>
                    <span className="error-message">{errors?.notes}</span>
                </div>

                <div className="field">
                    <label>Practice Location</label>
                    {/* <PracticeLocationSelector locationId={isEdit ? props.initialData.practiceLocationId : null } dontResetState={true} allowEmpty={true} onSelected={onLocationChanged} isClearable={true} /> */}
                    <HPTSelect
                        isClearable
                        placeholder="All Locations"
                        className="react-select-container"
                        classNamePrefix="react-select"
                        options={practiceLocation}
                        name="practiceLocationId"
                        value={practiceLocation && practiceLocation.find((obj) => obj.practiceLocationId === locationId)}

                        onChange={(e) => {
                            if (e?.practiceLocationId) {
                                setLocationId(e.practiceLocationId);
                            }
                            else {
                                setLocationId(null);
                            }
                        }}
                        getOptionLabel={(option) => option.practiceLocation}
                        getOptionValue={(option) => option.practiceLocationId}
                    ></HPTSelect>
                    <small className="form-text text-muted">
                        **If no location is selected, this template will be shared across all practice locations.
                    </small>
                </div>
            </form>

            <div className="mt-3 d-flex justify-content-between modal-button-bar">
                <div className='col-auto'>
                    <button className="btn btn-primary"
                        onClick={(e) => {
                            e.preventDefault();
                            formData.practiceLocationId ? submitHandler(formData) : setConfirm(true)
                        }}
                        disabled={!FormValidatorService.checkForm(errors, formData, required)}
                    >
                        {isEdit ? 'Update' : 'Save'}
                    </button>
                </div>
                <div className='col-auto'>
                    <button className="btn btn-secondary float-right" onClick={(e) => { e.preventDefault(); props.onClose() }}> Cancel </button>
                </div>
            </div>

            <ModalBox
                open={confirm}
                title="Confirm - Shared Template"
                onClose={() => { setConfirm(false); }}
                size="small"
                confirmButton="Confirm"
                onCloseSuccess={() => { setConfirm(false); submitHandler(formData); }}
            >
                <b>Note:</b> Saving this note template without selecting a practice location will make it shared across all locations in your practice. Do you want to proceed?
            </ModalBox>
        </>
    )
}

export default NoteTemplateForm
